import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import axiosInstance from "utils/axios";

export const loginAction = createAsyncThunk(
  "user/login",
  async ({ Email, Password, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/login", {
        Email,
        Password,
      });

      if (response.status === 200) {
        onSuccess();
        console.log(response.data.details);
        return response.data.details;
      } else if (response.status === 204) {
        const errorMessage = "Wrong Email Or Password";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      } else {
        const errorMessage = response.data.details || "Login failed";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Login failed";
      toast.error(errorMessage);
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getUsers = createAsyncThunk(
  "users/get-AllUsersData",
  async (thunkAPI) => {
    try {
      const response = await axiosInstance.get("/Auth/dashboard");
      console.log("response: ", response);

      if (response.status === 200) {
        toast.success("get all data");
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Login failed";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const deleteUsers = createAsyncThunk(
  "users/deleteUserData",
  async ({ userID, onSuccess }, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `/Auth/delete-user/${userID}`
      );
      if (response.status === 200) {
        onSuccess();
        toast.success("Teamlead deleted successfully");
        return response.data.details;
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Unable to delete";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const forgotPasswordAction = createAsyncThunk(
  "user/forgot-password",
  async ({ email, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/forgot-password", {
        email,
      });

      if (response.status === 200) {
        onSuccess(email);
        return response.data.details;
      } else if (response.status === 204) {
        const errorMessage = "Wrong Email Or Password";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      } else {
        const errorMessage = response.data.details || "Operation failed";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Operation failed";
      toast.error(errorMessage);
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "user/verify-otp",
  async ({ payload, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/verify-otp", {
        payload,
      });

      if (response.status === 200) {
        onSuccess();
        return response.data.details;
      } else if (response.status === 204) {
        const errorMessage = "Wrong Email Or Password";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      } else {
        const errorMessage = response.data.details || "Operation failed";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Operation failed";
      toast.error(errorMessage);
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const resetPasswordAction = createAsyncThunk(
  "user/reset-password",
  async ({ payload, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/reset-password", {
        payload,
      });

      if (response.status === 200) {
        onSuccess();
        return response.data.details;
      } else if (response.status === 204) {
        const errorMessage = "Wrong Email ";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      } else {
        const errorMessage = response.data.details || "Operation failed";
        toast.error(errorMessage);
        onError(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details || error.message || "Operation failed";
      toast.error(errorMessage);
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);
